<template>
  <div>
    <h2>Clientes</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogForm" max-width="800px">
            <ClientForm
              v-if="dialogForm"
              :selectedItemId="selectedItem.id"
              v-on:onClose="closeFormModal"
            />
          </v-dialog>
          <v-dialog v-model="dialog" persistent max-width="940">
            <v-card>
              <v-card-title>Adicionar Saldo GPX</v-card-title>
              <v-divider></v-divider>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Valor"
                      required
                      hide-details="auto"
                      v-model="saldo"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <br />
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDialog">
                  Cancelar
                </v-btn>
                <v-btn
                  color="#0dc4b8"
                  text
                  type="submit"
                  @click="addsaldo"
                  :disabled="isLoading"
                  :loading="isLoading"
                >
                  Adicionar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogactives" persistent max-width="940">
            <v-card>
              <v-card-title>Transferir saldo de ativos</v-card-title>
              <v-divider></v-divider>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    Escolha o ativo e digite a quantidade a ser transferida:
                    <v-select
                      v-model="selectedActiveId"
                      :items="actives"
                      item-text="name_token"
                      item-value="id"
                      label="Ativos"
                      return-object
                      single-line
                      v-on:change="loadAmountAvailableTokensByActive()"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Confira a quantidade disponível"
                      disabled
                      hide-details="auto"
                      v-model="dialogActivesAvailable"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Digite a quantidade a ser transferida"
                      required
                      hide-details="auto"
                      v-model="dialogActivesAmount"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Para finalizar, digite a senha do administrador"
                      required
                      hide-details="auto"
                      type="password"
                      v-model="dialogActivesPassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <br />
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDialogActives">
                  Cancelar
                </v-btn>
                <v-btn
                  color="#0dc4b8"
                  text
                  type="submit"
                  @click="transferActivesToUser"
                  :disabled="isLoading"
                  :loading="isLoading"
                >
                  Transferir
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom v-if="permissions['read_clients']">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="openFormModal(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-account-details</v-icon
            >
          </template>
          <span>Ver Detalhes</span>
        </v-tooltip>
        <v-tooltip bottom v-if="permissions['edit_clients'] && item.is_active">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="changeStatus(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-account-cancel</v-icon
            >
          </template>
          <span>Inativar Cliente</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-else-if="permissions['edit_clients'] && !item.is_active"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="changeStatus(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-account-check</v-icon
            >
          </template>
          <span>Ativar Cliente</span>
        </v-tooltip>
        <v-tooltip bottom v-if="permissions['edit_clients'] && item.is_active">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="openFormModal2(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-wallet</v-icon
            >
          </template>
          <span>Gerar Saldo</span>
        </v-tooltip>
        <v-tooltip bottom v-if="permissions['edit_clients'] && item.is_active">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="openFormModal3(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-bank-transfer-in</v-icon
            >
          </template>
          <span>Transferir ativos</span>
        </v-tooltip>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
import ClientsService from "../../services/clients.service";
import ClientForm from "./_form.vue";

import UsersService from "../../services/users.service";
import Api from "../../services/api.service";

export default {
  name: "Clients",
  components: {
    ClientForm,
  },
  data: () => ({
    data: [],
    dialogForm: false,
    dialog: false,
    dialogactives: false,
    saldo: 0,
    headers: [
      { text: "ID", value: "id" },
      { text: "Nome", value: "first_name" },
      { text: "Sobrenome", value: "last_name" },
      { text: "Email", value: "email" },
    ],
    isLoading: true,
    page: 1,
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {},
    sortBy: "clients.id",
    to: 0,
    total: 0,
    totalPages: 0,
    actives: [],
    selectedActiveId: null,
    dialogActivesAvailable: '',
    dialogActivesPassword: '',
    dialogActivesAmount: ''
  }),
  computed: {
    ...mapGetters(["permissions"]),
  },
  filters: {
    formatList(list) {
      return list
        .map((e) => e.name)
        .sort()
        .join(", ");
    },
  },
  watch: {
    dialogForm(val) {
      if (val && this.selectedIndex == -1 && this.$refs.form)
        this.$refs.form.resetValidation();
      val || this.closeFormModal();
    },
    page: function () {
      this.loadData();
    },
    searchFilter: {
      handler() {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    if (
      this.permissions["read_clients"] ||
      this.permissions["edit_clients"] ||
      this.permissions["delete_clients"]
    ) {
      this.headers.push({ text: "Ações", value: "actions", sortable: false });
    }

    this.loadData();
    this.loadActives();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    changeStatus(item) {
      let selectedIndex = this.data.indexOf(item);
      this.isLoading = true;
      UsersService.changeStatus({ is_active: !item.is_active }, item.user_id)
        .then(() => {
          this.data[selectedIndex].is_active = !item.is_active;

          if (!item.is_active)
            this.showSnackbar({
              text: "Usuário inativado com sucesso!",
              color: "success",
            });
          else
            this.showSnackbar({
              text: "Usuário ativado com sucesso!",
              color: "success",
            });
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Ocorreu um erro inesperado",
            color: "error",
          });
        })
        .finally(() =>
          setTimeout(() => {
            this.isLoading = false;
          }, 300)
        );
    },

    addsaldo() {
      if (!this.saldo > 0) {
        this.showSnackbar({
          text: "Preencha o saldo para continuar.",
          color: "error",
        });
        return false;
      }

      this.isLoading = true;

      let data = new FormData();

      data.append("qtd", this.saldo);
      data.append("id", this.selectedItem.user_id);

      Api.post("balanceGpxcoin", data, {
        header: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.loadData();
          this.showSnackbar({
            text: "Saldo adicionado com sucesso!",
            color: "success",
          });
          this.closeDialog();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.showSnackbar({
            ext: "Ops! Ocorreu um erro, tente novamente.",
            color: "error",
          });
        });
    },

    clearForm() {
      this.selectedItem = {};
      this.selectedIndex = -1;
    },

    closeFormModal() {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.clearForm();
      });
    },
    closeDialog() {
      this.dialog = false;
      this.selectedIndex = -1;
      this.isLoading = false;
      this.saldo = 0;
    },
    closeDialogActives() {
      this.dialogactives = false;
      this.selectedIndex = -1;
      this.isLoading = false;
      this.dialogActivesAmount = 0;
      this.selectedActiveId = null;
      this.dialogActivesAvailable = 0;
      this.dialogActivesPassword = '';
    },

    loadData() {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
      };

      if (this.searchFilter.query)
        params["filter[nameOrEmail]"] = this.searchFilter.query;

      ClientsService.get(params)
        .then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items;
          this.page = current_page;
          this.from = from;
          this.to = to;
          this.total = total;
          this.totalPages = Math.ceil(this.total / this.perPage);
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops! Ocorreu um erro inesperado",
            color: "error",
          });
        })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    openFormModal(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogForm = true;
    },
    openFormModal2(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = item;
      this.openDialog();
    },
    openFormModal3(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = item;
      this.dialogactives = true;
      this.isLoading = false;
    },

    openDialog() {
      this.dialog = true;
      this.isLoading = false;
    },

    loadActives() {
      Api.get('/actives').then((response) => {
        if(response.data && response.data[0].length > 0) {
          this.actives = response.data[0].filter((el) => (!el.cryptoactive));
        }
      })
    },

    loadAmountAvailableTokensByActive() {
      Api.get('/actives/'+this.selectedActiveId.id).then((response) => {
        if(response.data?.count) {
          this.dialogActivesAvailable = response.data?.count;
        }
      });
    },

    transferActivesToUser() {
      if(confirm('Você realmente deseja transferir '+this.dialogActivesAmount+' tokens?')) {
        Api.post('/transfer/storeAdm', {
          user_id : this.selectedItem.user_id, 
          active_id : this.selectedActiveId.id, 
          amount : this.dialogActivesAmount, 
          password : this.dialogActivesPassword, 
        }).then(() => {
          this.showSnackbar({
            text: "Tokens transferidos com sucesso!",
            color: "success",
          });
          this.closeDialogActives();
        })
        .catch((error) => {
          if(error.response?.data?.message) {
            this.showSnackbar({
              text: error.response?.data?.message,
              color: "error",
            });
          }else{
            this.showSnackbar({
              text: "Ops! Ocorreu um erro inesperado",
              color: "error",
            });
          }
        });
      }
    }
  },
};
</script>
